import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { PaymentsService } from 'src/app/services/payments.service';
import { TableHeadingsService } from 'src/app/services/table-headings.service';
import Swal from 'sweetalert2';
import { PaginationComponent } from '../../../components/layout/pagination/pagination.component';

@Component({
  selector: 'app-payments-table',
  templateUrl: './payments-table.component.html',
  styleUrls: ['./payments-table.component.scss']
})
export class PaymentsTableComponent implements OnInit {
  @ViewChild('paginationComponent') paginationComponent: PaginationComponent;
  @Input() mobile: boolean = false;
  
  public tableHeads = [];
  public dataIndividualReport = [];
  public searchString: string;
  public paymentsResponse: any = [];
  public search: any = {};
  public currentPage = 1;
  public cantPages = 10;


  constructor(public tableHeadings: TableHeadingsService, private payments: PaymentsService) { }

  ngOnInit() {
    this.getpayments(1);
  }

  goToPage({ currentPage }) {
    this.currentPage = currentPage;
    this.getpayments(currentPage);
  }

  preprocessDate(dateString: string): Date {
    // Eliminar los decimales de los segundos
    const withoutMilliseconds = dateString.replace(/(\.\d+)?$/, '');
    return new Date(withoutMilliseconds);
  }

  getpayments(currentPage: number) {
    this.search.currentPage = currentPage;
    this.search.perPage = 10;
    this.payments.getPaymentsTable(this.search).subscribe(
      (paymentsResponse: any) => {
        if (paymentsResponse.length < 1) {
          this.noData(paymentsResponse);
          this.paymentsResponse = [];
          return;
        }
        this.paymentsResponse = paymentsResponse['data'];
        this.cantPages = paymentsResponse['totalPage'];
      },
      (error: any) => {
        this.cantPages = 0;
        this.noData(error);
        this.paymentsResponse = [];
        this.handleResetPagination();

      }
    );
  }

 
  handleResetPagination() {
    if (this.paginationComponent) {
      this.paginationComponent.reset();
    }
  }

  noData(error: any) {
    console.log(error);
    Swal.fire({
      type: "info",
      title: "No hay información disponible",
      text: "",
    });
  }

  filter(value: string) {
    this.searchString = value;
  }

}
